import React from 'react';
import Grid from '@digital-hig/grid';
import PropTypes from 'prop-types';
import { useNavigate, useParams } from 'react-router-dom';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SuccessStoriesContextConsumer } from '../../../common/context/success-stories/context';
import SuccessStoriesRootElement from './style';
import { SuccessStoriesStateInterface } from '../../../common/context/success-stories/interface';
import CardDetails from '../../../common/cardDetails/cardDetails';
import CardCarousel from '../../../common/cardCarousel';
import { isMobileDevice } from '../../../utils/srp.util';
import ListingShimmer from '../../srp/Listing/listingShimmer';
import { getSuccessStoriesCardBaseURL } from '../../../utils/success-stories.util';

const MoreSuccessStories = ({
  partnerDetail = SuccessStoriesStateInterface.partnerDetail,
  fetchSuccessStoriesData,
  loading,
}) => {
  const { moreSuccessStories = [] } = partnerDetail || {};

  const param = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const handleViewMore = async (item) => {
    if (item.title && item.id) {
      const baseUrl = getSuccessStoriesCardBaseURL(param.locale, { name: item.title, id: item.id });
      navigate(baseUrl);
      await fetchSuccessStoriesData(item.id);
    }
  };

  const getLink = (element) => getSuccessStoriesCardBaseURL(param.locale, { name: element.title, id: element.id });
  return (
    <SuccessStoriesRootElement>
      <Box className="page-container">
        <Typography variant="headline-medium" data-testid="More success stories" mb={6}>
          {t('More success stories')}
        </Typography>
        {!isMobileDevice() && (
          <Grid className="grid-col">
            {(!!moreSuccessStories.length) && moreSuccessStories.map((item) => (
              <CardDetails
                key={`story-card-${item.id}`}
                handleViewMore={() => handleViewMore(item)}
                displayName={item.title}
                headline={item.customer_challenge}
                type="contentOnly"
                view
                link={getLink(item)}
                loading={loading}
                dataWatLoc="success stories"
                dataWatVal="load more"
              />
            ))}
            {(loading) && [...Array(3).keys()].map((e) => (
              <ListingShimmer key={e} />
            ))}
          </Grid>
        )}
        {isMobileDevice() && (
          <CardCarousel
            dataWatLoc="success stories"
            dataWatVal="load more"
            dataList={moreSuccessStories}
            getLink={getLink}
            handleViewMore={handleViewMore}
            displayName="title"
            headline="customer_challenge"
            type="contentOnly"
            loading={loading}
            view
          />
        )}
      </Box>
    </SuccessStoriesRootElement>
  );
};
MoreSuccessStories.propTypes = {
  partnerDetail: PropTypes.shape({}),
  fetchSuccessStoriesData: PropTypes.func,
  loading: PropTypes.bool,
};
MoreSuccessStories.defaultProps = {
  partnerDetail: {},
  fetchSuccessStoriesData: () => {},
  loading: false,
};
export default SuccessStoriesContextConsumer(MoreSuccessStories);
